/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_Too_LargeInputs */

const vi_file_upload_error_too_large = /** @type {(inputs: File_Upload_Error_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tệp quá lớn. Ảnh/video tối đa 50MB.`)
};

/**

* @param {File_Upload_Error_Too_LargeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_too_large = /** @type {((inputs?: File_Upload_Error_Too_LargeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_Too_LargeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_too_large(inputs)
});